import apis from "../../core/apis.js";

class BookingsResource {
  constructor($resource, Authentication) {
    "ngInject";

    this.$resource = $resource;
    this.Authentication = Authentication;
  }

  getAll(options) {
    return this.$resource(apis.bookings).get(options);
  }

  get(id) {
    return this.$resource(apis.bookings + id).get();
  }

  dailyStats() {
    return this.$resource(apis.bookings + "/count/daily").get();
  }

  weeklyStats() {
    return this.$resource(apis.bookings + "/count/weekly").get();
  }

  transferSuggestions(id) {
    return this.$resource(apis.bookings + id + "/transfer_suggestions").get();
  }
  transfer(id, item) {
    return this.$resource(apis.bookings + id + "/transfer").save(item);
  }
  monthlyStats() {
    return this.$resource(apis.bookings + "/count/monthly").get();
  }

  post(item) {
    return this.$resource(apis.bookings).save(item);
  }

  update(id, item) {
    return this.$resource(apis.bookings + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }

  checkIn(id) {
    return this.$resource(apis.bookings + id + "/check_in").save();
  }

  checkOut(id) {
    return this.$resource(apis.bookings + id + "/check_out").save();
  }

  pay(id, amount) {
    return this.$resource(apis.bookings + id + "/pay").save(amount);
  }

  cancel(id, item) {
    return this.$resource(apis.bookings + id + "/cancel").save(item);
  }

  cashCollectionResolve(id, isCaptainExempted) {
    return this.$resource(apis.bookings + id + "/cash_collection_resolve").save(
      isCaptainExempted
    );
  }

  miss(id) {
    return this.$resource(apis.bookings + id + "/miss").save();
  }

  downloadInvoicePdf(id) {
    return this.$resource(`${apis.bookings}${id}/invoice/pdf`).get();
  }
  getPendingBooking(options) {
    return this.$resource(
      apis.bookings + "pending",
      {},
      {
        get: {
          method: "GET",
          params: options,
        },
      }
    ).get(options);
  }
  selfAssignBookingReview(id) {
    return this.$resource(
      `${apis.bookings}pending/${id}/self_assign`,
      {},
      {
        save: {
          method: "POST",
        },
      }
    ).save();
  }
  approveBooking(id) {
    return this.$resource(
      `${apis.bookings}pending/${id}/approve`,
      {},
      {
        save: {
          method: "POST",
        },
      }
    ).save();
  }
  rejectBooking(id, reason) {
    return this.$resource(
      `${apis.bookings}pending/${id}/reject`,
      {},
      {
        save: {
          method: "POST",
        },
      }
    ).save({ rejection_reason: reason });
  }
}

export default BookingsResource;



// WEBPACK FOOTER //
// ./src/resources/bookings/bookings.resource.js